<template>
  <div class="indoor-site-selector">
    <b-form-select
      v-model="modelValue"
      v-bind:options="options"
      v-bind:size="size"
      v-bind:state="state"
      v-bind:disabled="disabled"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'

/** すべての現場ID */
const ALL_INDOOR_SITE_ID = -1

/**
 * 現場選択コンポーネント
 */
export default {
  name: 'AppIndoorSiteSelector',
  props: {
    /**
     * すべてのを選択している時に表示されるラベル(必須プロパティ)
     */
    selectedAllLabel: {
      type: String,
      required: true,
    },
    /**
     * 選択している現場ID
     */
    value: {
      type: Number,
      default: ALL_INDOOR_SITE_ID,
    },
    /**
     * サイズ
     * @values sm, md, lg
     */
    size: {
      type: String,
      default: 'sm',
    },
    /**
     * バリデーション状態
     */
    state: {
      type: Boolean,
      default: null,
    },
    /**
     * 非活性の場合はtrue
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { handleApiError } = useHandleApiError(props, context)
    return { handleApiError }
  },
  data: function () {
    return {
      modelValue: this.value,
    }
  },
  computed: {
    ...mapGetters('indoorSite', {
      /**
       * 現場データ
       * @type {Array.<Object>}
       */
      indoorSites: 'indoorSites',
    }),
    /**
     * 選択肢
     * @type {Array.<Object>}
     */
    options: function () {
      return [
        { value: ALL_INDOOR_SITE_ID, text: this.selectedAllLabel },
        ...this.indoorSites.map((item) => ({
          value: item.id,
          text: item.site_name,
        })),
      ]
    },
    /**
     * 公開値
     * @type {Number}
     */
    publicValue: function () {
      return this.modelValue === ALL_INDOOR_SITE_ID ? null : this.modelValue
    },
  },
  created: function () {
    this.$_getIndoorSites()
  },
  watch: {
    value: function () {
      this.modelValue = this.value
    },
    publicValue: function () {
      this.$_emitChangedEvent()
    },
  },
  methods: {
    ...mapActions('indoorSite', {
      /**
       * 現場更新
       */
      $_updateIndoorSites: 'updateIndoorSitesWithThrottle',
    }),

    /**
     * 現場データ取得
     */
    $_getIndoorSites: async function () {
      try {
        await this.$_updateIndoorSites()
      } catch (error) {
        this.handleApiError(error)
      }
    },

    /**
     * 変更イベントを発行する
     */
    $_emitChangedEvent: function () {
      /**
       * 現場選択変更イベント
       *
       * @param {Number} id 現場ID
       */
      this.$emit('indoor-site-changed', this.publicValue)
    },
  },
}
</script>
